import { Box, Typography } from "@mui/material";
import ContainerWrapper from "../../components/ContainerWrapper/ContainerWrapper";
import ActionButton, {
  ActionButtonVariant
} from "../../components/Button/ActionButton";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";

const columnSx = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 2
};

const messageSx = {
  ...typography.body.l,
  color: semanticColors.text.primary
};

/**
 * The screen standing in for the form when the request cannot be made at all:
 * the patient could not be read, or no payment account is approved yet. Both
 * are a sentence and a way out, so they share one component.
 */
export default function RequestPaymentMessage({
  message,
  actionLabel,
  onAction,
  variant
}: {
  message: string;
  actionLabel: string;
  onAction: () => void;
  variant?: ActionButtonVariant;
}) {
  return (
    <ContainerWrapper>
      <Box sx={columnSx}>
        <Typography sx={messageSx}>{message}</Typography>
        <ActionButton
          label={actionLabel}
          onClick={onAction}
          variant={variant}
        />
      </Box>
    </ContainerWrapper>
  );
}
